import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireCorporate?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireCorporate = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', {
    path: location.pathname,
    isAuthenticated,
    isLoading,
    user: user?.username,
    role: user?.role
  });

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#616161'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login');
    // Clear any stale auth token that might be causing issues
    localStorage.removeItem('auth_token');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check corporate access if required
  if (requireCorporate && !user?.is_corporate) {
    return <Navigate to="/dashboard" replace />;
  }

  console.log('Access granted');
  return <>{children}</>;
};

export default ProtectedRoute;
